<template>
<div :class="subItem.type === 'group' ? 'item' : '' ">
    <span class="subgroup-label" v-if="subItem.type === 'group'">
      {{subItem.translation.name}}
    </span>
    <NavbarCustomOption v-if="subItem.type === 'option'" :footer="footer" :item="subItem" :level="1"/>
    <template v-else>
      <div class="hiddenList" :class="footer ? 'up' : ''" v-if="Object.keys(subItem.items).length != 0">
        <div 
          v-for="item in subItem.items"  
          v-show="item.status"
          :key="item.id"
        >
          <NavbarCustomSubItems :subItem="item" list/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import BaseDropdown from "../../argon/components/BaseDropdown";
import NavbarCustomOption from "./NavbarCustomOption"
export default {
  name: "NavbarCustomSubItems",
  components: {
    BaseDropdown,
    NavbarCustomOption
  },
  props: {
    subItem: Object,
    list: Boolean,
    footer: Boolean
  },
  methods: {
    setTarget(target) {
      if (target) return "_blank";
    }
  },
  computed: {
    color() {
      return this.$store.getters.COLOR;
    }
  }
};
</script>

<style scoped>
.nch--custom-menu {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.5;
  padding: 0 !important;
}

</style>
